module.exports = __webpack_public_path__ + "img/device_1011_2.5f773ac4.svg";